/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminImportUsageItemDto
 */
export interface AdminImportUsageItemDto {
    /**
     * Import source/platform name
     * @type {string}
     * @memberof AdminImportUsageItemDto
     */
    source: string;
    /**
     * Number of unique users who used this import
     * @type {number}
     * @memberof AdminImportUsageItemDto
     */
    usersCount: number;
    /**
     * Total number of trades imported via this source
     * @type {number}
     * @memberof AdminImportUsageItemDto
     */
    tradesCount: number;
    /**
     * Percentage of total users who used this import
     * @type {number}
     * @memberof AdminImportUsageItemDto
     */
    percentage: number;
}

export function AdminImportUsageItemDtoFromJSON(json: any): AdminImportUsageItemDto {
    return AdminImportUsageItemDtoFromJSONTyped(json, false);
}

export function AdminImportUsageItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminImportUsageItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source': json['source'],
        'usersCount': json['usersCount'],
        'tradesCount': json['tradesCount'],
        'percentage': json['percentage'],
    };
}

export function AdminImportUsageItemDtoToJSON(value?: AdminImportUsageItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source': value.source,
        'usersCount': value.usersCount,
        'tradesCount': value.tradesCount,
        'percentage': value.percentage,
    };
}

